import { LocalizedPageTitle, PortfolioLayout, PortfolioLayoutHeader } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { Stack } from '@optimus-web/core';
import { ExcelProcessingType } from '@mews-commander/data-access';
import { FileUploadSection } from './FileUploadSection';

export const ChannelManagerMapping = () => (
    <PortfolioLayout>
        <PortfolioLayoutHeader title={<LocalizedPageTitle textKey={TextKey.ChannelManagerMapping} />} />
        <Stack vertical spacing="600">
            <FileUploadSection title={TextKey.ChannelManagerRatePlural} type={ExcelProcessingType.ChannelManagerRate} />
            <FileUploadSection title={TextKey.ChannelManagerCompany} type={ExcelProcessingType.ChannelManagerCompany} />
        </Stack>
    </PortfolioLayout>
);
